import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import jwt_decode from "jwt-decode";
import { User } from "../_models";
import { BehaviorSubject, config, Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { map } from "rxjs/operators";
import { Router } from "@angular/router";
import { AccountService } from "./account.service";
import { Persona } from "../_models/persona";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<User>;

  constructor(
    private http: HttpClient,
    private router: Router,
    @Inject(LOCALE_ID) protected localeId: string,
    private accs: AccountService
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem("currentUser"))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(email: string, password: string) {
    return this.http
      .post<any>(`${environment.apiUrl}/api/jwt/login`, {
        Email: email,
        Password: password,
        RememberMe: false,
      })
      .pipe(
        map((res) => {
          const user = {
            token: res.token,
            refreshToken: jwt_decode(res.token)["refreshToken"],
          };
          if (user && user.token) {
            localStorage.setItem("currentUser", JSON.stringify(user));
            this.currentUserSubject.next(user);
          }

          return user;
        })
      );
  }

  externalLogin(returnUrl) {
    window.location.href = `${environment.apiUrl}/api/jwt/externallogin?returnUrl=${returnUrl}&localeId=${this.localeId}`;
  }

  refreshToken() {
    const url = `${environment.apiUrl}/api/jwt/refresh`,
      data = {
        token: this.currentUserValue.token,
        refreshToken:
          this.currentUserValue.refresh ||
          this.currentUserValue["refreshToken"],
      };
    return this.http.post(url, data);
    /*.pipe(
    map((res) => {
      const isToken = res && res['token'];
      if (isToken) {
        this.setActiveToken(res, '');
        return true;
      }

      return Observable.throw('Unauthorized');
    })
  );*/
  }

  setActiveToken(token, refresh, returnUrl) {
    const user = { token, refresh };
    localStorage.setItem("currentUser", JSON.stringify(user));
    this.currentUserSubject.next(user as User);
    if (returnUrl.length > 0) {
      this.router.navigateByUrl(returnUrl);
    }
    this.accs.getPersona().subscribe((per) => {
      const currUser = this.accs.extractData(per);
      this.accs.setUser(new Persona(currUser));
    });
  }

  logout() {
    return this.http.post<any>(`${environment.apiUrl}/api/jwt/logout`, null);
  }

  clearSession() {
    localStorage.removeItem("currentUser");
    localStorage.removeItem("loggedUser");
    this.currentUserSubject.next(null);
  }
}
